// Autogenerated file
export const clientStatisticsReportTypesEnum = {
    All: "All",
    OnlyLogists: "OnlyLogists",
    OnlyOrganizations: "OnlyOrganizations",
};
export const clientStatisticsReportTypes = [
    { label: "С группировкой", value: "All" },
    { label: "Только логисты", value: "OnlyLogists" },
    { label: "Только компании", value: "OnlyOrganizations" },
];
